<template>
  <div class="form-group">
    <label v-if="label" :for="id">{{label}}</label>
    <select class="form-control"
            v-bind:value="convertedValue"
            :id="id"
            v-bind="$attrs"
            v-bind:class="{ 'is-invalid': validation.$error }"
            v-on:change="updateInput($event)">
      <option value="Yes">Yes</option>
      <option value="No">No</option>
    </select>
    <div class="invalid-feedback" v-if="errorMessage">
      {{errorMessage}}
    </div>
  </div>
</template>

<script>
import { ValidationMixin } from '@/js/Mixins';

export default {
  name: 'YesNo',
  mixins: [ValidationMixin],
  inheritAttrs: false,
  props: {
    label: String,
    value: Boolean,
  },
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    this.id = `yesno-${this._uid}`
  },
  computed: {
    convertedValue() {
      return this.value ? 'Yes' : 'No';
    },
  },
  methods: {
    updateInput(event) {
      this.validation.$touch();
      this.$emit('input', event.target.value === 'Yes');
    },
  },
};
</script>

<style scoped>

</style>
